import { useContext, useMemo, useState } from "react";
import SlideButton from "react-slide-button";
import { useTranslation } from "react-i18next";
import { MachineCenterContext } from "../../contexts/MachineCenterContext/MachineCenterContext";
import Box from "@mui/material/Box";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { useStyles } from "./UptimeButton.styles";
import useUptimeDowntimeActionsHMI from "hooks/useUptimeDowntimeActionsHMI";
import { CircularProgress } from "@mui/material";
import { MQTTBrokerContext } from "contexts/MQTTBrokerContext/MQTTBrokerContext";

export const UptimeButton = () => {
    const { t } = useTranslation();
    const { machineStatus } = useContext(MachineCenterContext);
    const { isBrokerConnected, isLocalServerActive } = useContext(MQTTBrokerContext);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isReset, setIsReset] = useState<boolean>(false);
    const { handleMachineActiveUptime } = useUptimeDowntimeActionsHMI();
    const classes = useStyles();

    const disableSlider = useMemo(
        () => !isBrokerConnected || !isLocalServerActive,
        [isBrokerConnected, isLocalServerActive],
    );

    return (
        <Box className={classes.uptimeButtonContainer}>
            <SlideButton
                mainText={
                    <>
                        <span className={classes.mainTextTitle}>{t("HMI.machine_status.stopped").toUpperCase()}</span>
                        <Box className={classes.mainTitleIconIconContainer}>
                            <Box className={classes.mainTextTitleIconBox}>
                                <CheckCircleOutlinedIcon className={classes.mainTextTitleIcon} />
                            </Box>
                        </Box>
                    </>
                }
                overlayText={
                    <Box className={classes.overlayTextContainer}>
                        <CheckCircleOutlinedIcon className={classes.overlayTextDangerousOutlinedIconLeft} />
                        <span className={classes.overlayTextTitle}>
                            {t("HMI.machine_status.running").toUpperCase()}
                        </span>
                        <CheckCircleOutlinedIcon className={classes.overlayTextDangerousOutlinedIconRight} />
                    </Box>
                }
                reset={isReset}
                onSlideDone={async () => {
                    try {
                        setIsReset(false);
                        setIsLoading(true);
                        await handleMachineActiveUptime();
                        setIsLoading(false);
                    } catch {
                        setIsReset(true);
                        setIsLoading(false);
                    }
                }}
                caret={
                    isLoading ? (
                        <CircularProgress className={classes.overlayTextDangerousOutlinedIconRight} />
                    ) : (
                        <img src="/images/uptime_slide_button_icon.svg" alt="slide_button_icon" />
                    )
                }
                classList={`${classes.uptimeButton} ${disableSlider ? classes.disabledButton : ""}`}
                caretClassList={
                    !machineStatus
                        ? `${classes.uptimeButtonCaret} ${disableSlider ? classes.disabledCaret : ""}`
                        : classes.visibilityHidden
                }
                overlayClassList={`${machineStatus ? classes.uptimeButtonOverlay : classes.uptimeButtonOverlayColor} ${
                    disableSlider ? classes.disabledOverlay : ""
                }`}
                delta={2}
                minSlideWidth={0.8}
                minSlideVelocity={0.6}
                customCaretWidth={72}
            />
        </Box>
    );
};
